export const getCompany = state => state.company;
